define('SageDotCom/Utility/frontEnd',[
    "jquery",
    "SageDotCom/Utility/PageModeHelper",
    "SageDotCom/Utility/sanitizer",
    "slick",
    "matchHeight",
    "SageDotCom/DataLayer/Events/CustomerSuccess/storyClickEvent",
    "SageDotCom/Utility/passClickToGenesysBtn",
    "SageDotCom/Utility/LazyLoad",
    "SageDotCom/Utility/FaqSchema",
    "SageDotCom/Utility/ProductSchema",
    "SageDotCom/components/forms/AccountingForm",
    "eventManager",
    "ellipsis",
    "SageDotCom/Components/ProductCard/ProductCardSelection",
    "SageDotCom/DataLayer/Events/product-card-detail",
    'SageDotCom/Components/SlickSliderSettings',
    "SageDotCom/DataLayer/Events/personalisationOnLoad",
    "SageDotCom/Components/ProductCardAlignment",
    "SageDotCom/Components/Videos/BrightcoveVideo",
    'SageDotCom/DataLayer/tealium',
    "SageDotCom/DataLayer/Events/skinnyBanner",
    "SageDotCom/Components/ScoreFixes/SageTabPanel",
    "SageDotCom/DataLayer/Global/tabsets",
    "SageDotCom/DataLayer/Global/slider",
    'promise-polyfill'
], function ($, pageMode, sanitizer, slick, matchheight, customerSuccessStoryClickEvent, passClickToGenesysBtn, LazyLoad, FaqSchema, ProductSchema, AccountingForm, eventManager, ellipsisConfig, productCardSelection, ProductCardDetailEvent, SlickSliderSettings, PersonalisationOnLoad, ProductCardAlignment, BrightcoveVideo, tealium, skinnyBannerEvent, tabPanel, tabsetTrackingEvents, sliderTrackingEvents) {
    function FrontEnd() { }

    FrontEnd.prototype.preloadAsync = function preloadAsync() {
        return new Promise((function (resolve, reject) {
            try {
                this.preload();
                resolve();
            } catch (err) {
                reject(err);
            }
        }).bind(this));
    }

    FrontEnd.prototype.postloadAsync = function postloadAsync() {
        return new Promise((function (resolve, reject) {
            try {
                this.postload();
                var scoreNav = $(".score-nav .nav.navbar-nav.score-nav/*.links*/");
                scoreNav.each(function (index, scoreNavItem) {
                    if (scoreNavItem != null && scoreNavItem.children.length < 1) {
                        $(scoreNavItem).attr("role", "none");
                        $(scoreNavItem).attr("aria-hidden", "true");
                    } else if (scoreNavItem !== null && scoreNavItem.children.length >= 1) {
                        if ($(scoreNavItem).attr("role") === "menu") {
                            $(scoreNavItem).removeAttr("role");
                        }
                        $(scoreNavItem).children().each(function (i, listItem) {
                            if ($(listItem).attr("role") === "menuitem") {
                                $(listItem).removeAttr("role");
                            }
                        });
                    }
                });
                var navWrapper = document.querySelector(".sticky-nav .score-megamenu .score-nav-wrapper .score-nav .nav.navbar-nav.score-nav.links");
                if (navWrapper != null && navWrapper.children.length < 1) {
                    var navWrapperTitle = document.querySelector(".sticky-nav .score-megamenu .score-nav-wrapper .score-nav .navbar-header.score-navbar-header .navbar-brand");
                    if (navWrapperTitle != null) {
                        navWrapperTitle.classList.add("no-menu-items");
                    }
                }

                
                resolve();
            }
            catch (err) {
                reject(err);
            }
        }).bind(this));
    }

    // run any logic before score modules load
    FrontEnd.prototype.preload = function preload() {
        if (pageMode.IsLive() || pageMode.IsPreview()) {

            //fix btn with hash in the case user is in the same page.
            //for instance = url = www.sage.com/es-es/erp/   -> hash button = "/es-es/erp/#form" -> This case remove the "/es-es/erp/". 
            //In any other page, keep it.
            [].forEach.call(document.querySelectorAll("a[href*='#']"), function (elem) {
                var href = elem.getAttribute('href');
                if (href == null) {
                    return;
                }

                href = href.trim().toLowerCase();

                var index = href.indexOf("#");
                if (index > -1 && index < href.length - 1) {

                    //for cases where the hash is in the same page
                    if (href.indexOf("#") != 0) {

                        //get the hash
                        var hashLoc = href.indexOf("#");
                        var hash = "";
                        if (hashLoc < href.length) {
                            hash = href.substr(hashLoc);
                        }

                        //validate if it is the url + hash in the same page
                        var url = window.location.pathname.trim().toLowerCase();
                        if (url.endsWith("/")) {
                            //remove last "/"
                            url = url.slice(0, -1);
                        }

                        if (href == url + hash || href == url + "/" + hash) {
                            //remove the path part in case it is the same page
                            elem.setAttribute('href', hash);
                        }
                    }
                }
            });

            //Add easing for anchorpoint
            [].forEach.call(document.querySelectorAll('.score-button'), function (btnEl) {
                btnEl.addEventListener('click', this.anchorClickHandler.bind(this));
            }, this);

            // Fix for the caption white highlight to have match height
            [].forEach.call(document.querySelectorAll('.score-highlight.highlight--caption-white, .score-highlight.card-solid-heading-image-right'),
                function (elem) {
                    var divWrapper = document.createElement('div');
                    divWrapper.className = 'header-wrapper';
                    elem.prepend instanceof Function
                        ? elem.prepend(divWrapper)
                        : elem.insertBefore(divWrapper, elem.firstChild);

                    var imgEl = elem.querySelector('.image-wrapper');
                    var headerEl = elem.querySelector('.inner-heading');

                    if (imgEl) divWrapper.appendChild(imgEl);
                    if (headerEl) divWrapper.appendChild(headerEl);

                },
                this);

            // since jquery and jquery.matchHeight is slow, we want to run it in parallel to the main thread
            new Promise(function (resolve, reject) {
                try {
                    // match height style boxes within a container with a special "signal" class
                    $(".matchheight-stylebox .score-style-box").matchHeight(true);
                    $(".score-highlight.highlight__heading--colored .score-highlight-header").matchHeight(true);
                    $(".score-highlight.highlight--caption-white .score-highlight-body").matchHeight(true);
                    $(".score-highlight.highlight--caption-white .caption").matchHeight(true);
                    $(".score-flex-box.nested-alignment .score-highlight:not(:has(.image-wrapper))").matchHeight(true);

                    resolve();
                } catch (err) {
                    console.error(err);
                    reject(err);
                }
            });

            var navTabsEl = document.querySelector('.vertical-tabset .nav-tabs-wrapper-inner');
            // Vertical Tabset heading since we do not have this in our vertical tabset 
            // we are moving content spot in front of the ul of tabs
            if (navTabsEl) {
                [].forEach.call(document.querySelectorAll('.score-content-spot.vertical-tab-heading'), function (verticalTabHeadingEl) {
                    navTabsEl.prepend instanceof Function ? navTabsEl.prepend(verticalTabHeadingEl) : navTabsEl.insertBefore(verticalTabHeadingEl, navTabsEl.firstChild);
                }, this);
            }

            // Remove elements from the highlights that are empty.
            [].forEach.call(document.querySelectorAll('.score-highlight-body, .score-call-to-action, .score-highlight-header, .score-highlight .caption .inner-heading'), function (el) {
                // remove element
                if (el.innerHTML != null && el.innerHTML.replace(/\s+/g, '').length === 0) {
                    el.parentNode && el.parentNode.removeChild(el);
                }
            }, this);

            //Sitecore 9 multi-page form button fixes
            [].forEach.call(document.querySelectorAll('.accounting-submit-form input[type=\'submit\'].disabled'), function (el) { el.disabled = true; });
            [].forEach.call(document.querySelectorAll('.accounting-form input[type=submit].otp-button'), function (el) { el.setAttribute('type', 'button'); });
            [].forEach.call(document.querySelectorAll('.form-nav-section input[type=submit].form-next-btn, .form-nav-section input[type=submit].form-back-btn'), function (el) { el.setAttribute('type', 'button'); });

            [
                '.form-nav-section input[type=button].form-next-btn',
                '.form-nav-section input[type=button].form-back-btn'
            ].forEach(function (query) {
                [].forEach.call(document.querySelectorAll(query), function (btnEl) {
                    var btnContainer = btnEl.parentNode;
                    var btnName = btnEl.value;
                    var newBtn = document.createElement('button');
                    newBtn.appendChild(document.createTextNode(btnName));

                    btnContainer.appendChild(newBtn);

                    [].forEach.call(btnEl.attributes, function (keyValue) {
                        newBtn.setAttribute(keyValue.name, keyValue.value);
                    });

                    btnContainer.removeChild(btnEl);
                }, this);
            }, this);

            // Let the document know when the mouse is being used
            document.body.addEventListener('mousedown', function () {
                document.body.classList.remove('using-kbd');
            });

            // Re-enable focus styling when Tab is pressed
            document.body.addEventListener('keydown', function (event) {
                if (event.key === 'Tab') {
                    document.body.classList.add('using-kbd');
                }
            });

            //for mobile
            if (window.innerWidth <= 768) {
                [].forEach.call(document.querySelectorAll('.customer-success-stories, .intacct-resources'), function (el) {
                    el.classList.add('is-mobile');
                }, this);
            }
        }

        //tabAccordion highlight height checking and hiding highlight if there is no space for it
        var countTabs = document.querySelectorAll('.sage-tabset-stripe-product .score-tab .tabAccordion-tabSet .nav-tabs > .nav-tab').length;
        // fetch panels and convert them into an array, so we won't have any issue with compatibility (IE)
        var tabAccordionPanels = [].slice.call(document.querySelectorAll('.sage-tabset-stripe-product .score-tab .tabAccordion-tabSet .panel.tab-pane.score-accordion-panel'));

        if (countTabs > 0 && tabAccordionPanels) {
            for (var i = countTabs - 1; i >= 0; i--) {
                var panel = tabAccordionPanels[i];
                panel.classList.add('active');
                panel.classList.add('in');

                var tabAccordionRightColumn = document.querySelectorAll('.sage-tabset-stripe-product .tabAccordion-tabSet .panel.tab-pane.score-accordion-panel .score-right .sage-list-group-product')[i];
                var tabAccordionLeftColumnHighlight = document.querySelectorAll('.sage-tabset-stripe-product .tabAccordion-tabSet .panel.tab-pane.score-accordion-panel .score-left .score-highlight')[i];
                var tabAccordionLeftColumnImgHighlight = document.querySelectorAll('.sage-tabset-stripe-product .tabAccordion-tabSet .panel.tab-pane.score-accordion-panel .score-left .score-highlight img')[i];

                var tabAccordionRightColumnHeight = tabAccordionRightColumn ? tabAccordionRightColumn.offsetHeight : 0;
                var tabAccordionLeftColumnHighlightHeight = tabAccordionLeftColumnHighlight ? tabAccordionLeftColumnHighlight.offsetHeight : 0;
                var tabAccordionLeftColumnImgHighlightHeight = tabAccordionLeftColumnImgHighlight ? tabAccordionLeftColumnImgHighlight.offsetHeight : 0;

                var heightColumnDifference = tabAccordionRightColumnHeight - tabAccordionLeftColumnHighlightHeight;
                var allowableHeightDifference = 40;

                if (tabAccordionRightColumn && tabAccordionLeftColumnHighlight && tabAccordionLeftColumnImgHighlight) {
                    if (heightColumnDifference <= allowableHeightDifference) {
                        if (heightColumnDifference + tabAccordionLeftColumnImgHighlightHeight <= allowableHeightDifference) {
                            tabAccordionLeftColumnHighlight.parentNode.removeChild(tabAccordionLeftColumnHighlight);
                        }
                    }
                }

                panel.classList.remove('active');
                panel.classList.remove('in');
            }
            tabAccordionPanels[0].classList.add('active');
            tabAccordionPanels[0].classList.add('in');
        }

        // install pass click event to genesys btn plugin
        new passClickToGenesysBtn().installAsync();

        $(".ccaas-trigger").removeAttr("href");

        // Fix for the share ticker modal to redraw itself
        // when it is opened in the modal on mobile.
        var shareIFrameTimeout = undefined;
        [].forEach.call(document.querySelectorAll('.investors .share-price-ticker'), function (el) {
            el.addEventListener('click', function (e) {
                var iframeEl = document.querySelector('.iframe-component');
                iframeEl = iframeEl.parentNode.removeChild(iframeEl);
                if (!shareIFrameTimeout) {
                    shareIFrameTimeout = setTimeout(function () {
                        document.querySelector('.share-ticker-modal .score-iframe').appendChild(iframeEl);
                    }, 10);
                }
            });
        }, this);

        const utagQueue = (w) => {
            if (w.utag) return; var u = w.utag = {}; u.e = []; u.view = function (a, b, c) {
                u.e.push(

                    { a: a, b: b, c: c, d: "view" }
                )
            };
            u.link = function (a, b, c) {
                u.e.push(

                    { a: a, b: b, c: c, d: "link" }
                )
            };
            u.track = function (d, a, b, c) {
                typeof d === "object" ? u.e.push(

                    { a: d.data, b: (d.cfg ? d.cfg.cb : null), c: (d.cfg ? d.cfg.uids : undefined), d: d.event }
                ) : u.e.push(

                    { a: a, b: b, c: c, d: d }
                );
            };
        };

        utagQueue(window);

    };



    // run any logic after score modules have loaded
    FrontEnd.prototype.postload = function postload() {
        LazyLoad.init();

        const isValidInternalUrl = (url) => {
            try {
                const parsedUrl = new URL(url, window.location.origin);
                return parsedUrl.origin === window.location.origin;
            } catch (e) {
                return false;
            }
        };
        // add add-to-cart event to button with "card trigger" style selection
        $(".page-wrapper, .modal").on("click", ".cart-trigger", function (event) {
            event.preventDefault();
            const originalURL = $(this).attr("href");
            if (originalURL && isValidInternalUrl(originalURL)) {
                const redirectToURL = () => { location.href = originalURL; };
                if (originalURL.includes("sku=")) {
                    const productService = new ProductCardDetailEvent();
                    var entryMethod = $(this).parents(".modal").get(0) ? "Popup" : "Product Card";
                    productService.triggerAddToCartTealiumEvent(originalURL, $(this), entryMethod, redirectToURL);
                } else {
                    redirectToURL();
                }
            }

        });


        // Keeping the highlight cards height equal for extra content seperating the cards into two parts
        // run matchHeight after slick initializes
        $(".score-slick-slider .score-highlight.highlight__heading--colored .score-highlight-header").matchHeight(true);
        $(".score-slick-slider .score-highlight.highlight--caption-white .header-wrapper")
            .matchHeight({ byRow: false });
        $(".score-slick-slider .score-highlight.highlight--caption-white").matchHeight({ byRow: false });
        $(".score-slick-slider .score-highlight.highlight--caption-white .caption").matchHeight({ byRow: false });
        
        //ensure any content in slider/carousel is matchHeighted only with content in the same slider/carousel
        $(".score-carousel").each(function () {
            $(this).find(".score-carousel-pane-body:not(.score-carousel-pic-pane-body)").matchHeight({
                byRow: false
            });
        });

        $('.score-slick-slider').each(function () {
            $(this).find('.score-highlight').matchHeight({
                byRow: false
            });
        });


        //Create slick slider and settings here
        //Get element to create slick slider
        var $homeNavSlider =
            $(
                ".score-tab.sage-tab-outer .nav.nav-tabs:not(.sage-tab-inner .nav.nav-tabs, .sage-tab-home .nav.nav-tabs, .vertical-tabAccordion .nav.nav-tabs)"
            ).length >
                0
                ? $(
                    ".score-tab.sage-tab-outer .nav.nav-tabs:not(.sage-tab-inner .nav.nav-tabs, .sage-tab-home .nav.nav-tabs, .vertical-tabAccordion .nav.nav-tabs)"
                )
                : 0;
        var $homeContentSlider =
            $(
                ".score-tab.sage-tab-outer .tab-content:not(.sage-tab-inner .tab-content, .sage-tab-home .tab-content, .vertical-tabAccordion .tab-content)"
            ).length >
                0
                ? $(
                    ".score-tab.sage-tab-outer .tab-content:not(.sage-tab-inner .tab-content, .sage-tab-home .tab-content, .vertical-tabAccordion .tab-content)"
                )
                : 0;

        //Create settings for slicksliders
        var homeSettingNav = {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: true,
            infinite: false,
            swipeToSlide: true,
            touchThreshold: 5,
            focusOnSelect: true,
            asNavFor:
                ".score-tab.sage-tab-outer .tab-content:not(.score-tab.sage-tab-inner .tab-content, .score-tab.sage-tab-home .tab-content)"
        };

        var homeSettingContent = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            swipeToSlide: true,
            touchThreshold: 5,
            focusOnSelect: true,
            asNavFor:
                ".score-tab.sage-tab-outer .nav.nav-tabs:not(.score-tab .sage-tab-inner .nav.nav-tabs, .score-tab .sage-tab-home .nav.nav-tabs)"
        };

        //------------------------------
        //tabset sliders
        var $tabsetNavSlider = $('div[class="score-tab"] .nav.nav-tabs').length > 0 ? $('div[class="score-tab"] .nav.nav-tabs') : 0;
        var $tabsetContentSlider = $('div[class="score-tab"] .tab-content').length > 0 ? $('div[class="score-tab"] .tab-content') : 0;

        var $tabsetVNavSlider = $('.score-tab.vertical-tabset .nav.nav-tabs').length > 0 ? $('.score-tab.vertical-tabset .nav.nav-tabs') : 0;
        var $tabsetVContentSlider = $('.score-tab.vertical-tabset .tab-content').length > 0 ? $('.score-tab.vertical-tabset .tab-content') : 0;

        var tabsetNavSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: true,
            infinite: false,
            swipeToSlide: true,
            touchThreshold: 5,
            focusOnSelect: true,
            asNavFor: ' .tab-content'
        };

        var tabsetContentSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            swipeToSlide: true,
            touchThreshold: 5,
            focusOnSelect: true,
            asNavFor: ' .nav.nav-tabs'
        };

        var tabsetContentWithSliderInsideSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            swipe: false,
            swipeToSlide: false,
            touchMove: false,
            arrows: false,
            infinite: false,
            touchThreshold: 5,
            focusOnSelect: false,
            fade: true,
            speed: 200,
            cssEase: "ease-in-out"
        };

        var tabsetVNavSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: true,
            infinite: false,
            swipeToSlide: true,
            touchThreshold: 5,
            focusOnSelect: true,
            asNavFor:
                '.score-tab.vertical-tabset .tab-content'
        };

        var tabsetVContentSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            swipeToSlide: true,
            touchThreshold: 5,
            focusOnSelect: true,
            asNavFor: '.score-tab.vertical-tabset .nav.nav-tabs'
        };

        function getScopedSliderSettings(el, settings) {
            var outputSettings = $.extend(true, [], settings);
            var parent = $(el).parents(".score-tab")
            if (parent.length > 0) {
                var id = parent.attr("id");
                if (id !== "") {
                    outputSettings.asNavFor = "#" + id + outputSettings.asNavFor;
                }
            }

            return outputSettings;
        }

        function findActiveTabIndex(scoreTabEl) {
            let slider = $(scoreTabEl).find(".nav.nav-tabs").get(0);
            let $slider = $(slider);
            let activeTabIndex = 0;
            //Get the active slide

            $slider.find(".nav-tab").each(function (j, tabEl) {
                if (activeTabIndex === 0 && $(tabEl).hasClass("active")) {
                    activeTabIndex = j;
                }
            });

            return activeTabIndex;
        }

        //Call Slick on the element
        function makeSlick() {

            if ($homeNavSlider.length > 0) {
                if (!$homeNavSlider.hasClass("slick-initialized")) {
                    new Promise(function (resolve, reject) {
                        $homeNavSlider.slick(homeSettingNav);
                        resolve();
                    });
                }

                if (!$homeContentSlider.hasClass("slick-initialized")) {
                    new Promise(function (resolve, reject) {
                        $homeContentSlider.slick(homeSettingContent);
                        resolve();
                    });
                }

            }

            if ($tabsetNavSlider.length > 0) {
                $tabsetNavSlider.each(function (i, slider) {
                    $slider = $(slider);
                    if (!$slider.hasClass("slick-initialized")) {
                        new Promise(function (resolve, reject) {
                            let settings = getScopedSliderSettings(slider, tabsetNavSettings);
                            settings.initialSlide = findActiveTabIndex($slider.closest(".score-tab"));
                            $slider.slick(settings);

                            eventManager.trigger("lazy-animate-element", $slider.closest(".score-tab"));

                            $slider.removeAttr("role");
                            $slider.find(".nav-tab-btn").removeAttr("role");

                            resolve();
                        });
                    }
                });

                $tabsetContentSlider.each(function (i, contentSlider) {
                    $contentSlider = $(contentSlider);
                    if (!$contentSlider.hasClass("slick-initialized")) {
                        new Promise(function (resolve, reject) {
                            let closestTab = $contentSlider.closest(".score-tab");
                            var slickSliderContent = $contentSlider.find(".score-flex-box.slick-contents");
                            var isTabContentSlickSlider = slickSliderContent !== null && slickSliderContent !== undefined && slickSliderContent.length > 0;

                            if (isTabContentSlickSlider) {
                                $contentSlider.slick(tabsetContentWithSliderInsideSettings);
                            }
                            else {
                                let settings = getScopedSliderSettings(contentSlider, tabsetContentSettings);
                                settings.initialSlide = findActiveTabIndex(closestTab);

                                $contentSlider.slick(settings);
                            }

                            eventManager.trigger("lazy-animate-element", closestTab);
                            eventManager.trigger("lottie-load", closestTab);
                            $(window).trigger("resize-slick-arrows");
                            resolve();
                        });
                    }
                });


                // catch when slick slider changes the active tab
                $tabsetNavSlider.on('afterChange', function (event, slick, currentSlide) {

                    $tabsetNavSlider.find('.nav-tab').each(function () {
                        $(this).removeClass('active');
                    });

                    var activeTabLi = $tabsetNavSlider.find(".slick-current .nav-tab");
                    $(activeTabLi).addClass("active");

                    setTimeout(function () {
                        initTabset();
                    }, 10);
                });

                $tabsetNavSlider.on('beforeChange', function () {
                    setTimeout(function () {
                        // manually trigger matchHeight before the slick slider changes and renders new slide
                        $.fn.matchHeight._update();
                    }, 10);
                });
            }

            if ($tabsetVNavSlider.length > 0) {
                if (!$tabsetVNavSlider.hasClass("slick-initialized")) {
                    new Promise(function (resolve, reject) {
                        $tabsetVNavSlider.slick(tabsetVNavSettings);

                        eventManager.trigger("lazy-animate-element", $tabsetVNavSlider.closest(".score-tab"));

                        resolve();
                    });
                }

                if (!$tabsetVContentSlider.hasClass("slick-initialized")) {
                    new Promise(function (resolve, reject) {
                        $tabsetVContentSlider.slick(tabsetVContentSettings);

                        eventManager.trigger("lazy-animate-element", $tabsetVContentSlider.closest(".score-tab"));

                        resolve();
                    });
                }

                // catch when slick slider changes the active tab
                $tabsetVNavSlider.on('afterChange', function (event, slick, currentSlide) {
                    // remove active from all li

                    $tabsetVNavSlider.find('.nav-tab').each(function () {
                        $(this).removeClass('active');
                    });

                    var activeTabLi = $tabsetNavSlider.find(".slick-current .nav-tab");
                    $(activeTabLi).addClass("active");

                    setTimeout(function () {
                        initTabset();
                    }, 10);
                });

            }
        }

        function makeUnSlick() {
            if ($homeNavSlider.length > 0) {
                if ($homeNavSlider.hasClass("slick-initialized")) {
                    $(".slick-slide .nav-tab").not(".slick-slide .score-tab.sage-tab-inner .nav-tab").removeClass("active");

                    $homeNavSlider.slick("unslick");
                    $(".score-tab.sage-tab-outer .nav-tabs .nav-tab").not(".score-tab.sage-tab-inner .nav-tabs .nav-tab").first()
                        .addClass("active");

                    $(".score-tab.sage-tab-home .nav-tabs, .score-tab.vertical-tabAccordion .nav.nav-tabs").each(
                        function () {
                            $(this).children(".nav-tab").first().addClass("active");
                        });
                }
                if ($homeContentSlider.hasClass("slick-initialized")) {
                    $(".slick-slide .tab-pane").not(".slick-slide .score-tab.sage-tab-inner .tab-pane")
                        .removeClass("active in");

                    $homeContentSlider.slick("unslick");
                    $(".score-tab.sage-tab-outer .tab-pane").not(".score-tab.sage-tab-inner .tab-pane").first()
                        .addClass("active in");

                    $(".score-tab.sage-tab-home .tab-content, .score-tab.vertical-tabAccordion .tab-content").each(
                        function () {
                            $(this).children(".tab-pane").first().addClass("active");
                        });
                }
            }

            if ($tabsetNavSlider.length > 0) {
                $tabsetNavSlider.each(function () {
                    var $this = $(this);
                    if ($this.hasClass("slick-initialized")) {
                        $this.find(".slick-slide .nav-tab").removeClass("active");
                        $this.slick("unslick");
                        $this.find(".nav-tab").first().addClass("active");

                        $this.attr("role", "tablist");
                        $this.find(".nav-tab-btn").attr("role", "tab");
                    }
                });


                $tabsetContentSlider.each(function () {
                    var $this = $(this);
                    if ($this.hasClass("slick-initialized")) {
                        $this.find(".slick-slide .tab-pane").removeClass("active in");
                        $this.slick("unslick");
                        $this.find(".tab-pane").first().addClass("active in");
                        $this.find(".tab-pane").each(function () {
                            // Reinitialize the tabPanels
                            tabPanel.init({
                                scope: $(this)
                            });
                        });
                    }
                });
            }

            if ($tabsetVNavSlider.length > 0) {
                $tabsetVNavSlider.each(function () {
                    var $this = $(this);
                    if ($this.hasClass("slick-initialized")) {
                        $this.find(".slick-slide .nav-tab").removeClass("active");
                        $this.slick("unslick");
                        $this.find(".nav-tab").first().addClass("active");
                    }
                });


                $tabsetVContentSlider.each(function () {
                    var $this = $(this);
                    if ($this.hasClass("slick-initialized")) {
                        $this.find(".slick-slide .tab-pane").removeClass("active in");
                        $this.slick("unslick");
                        $this.find(".tab-pane").first().addClass("active in");
                    }
                });
            }
        }

        // hide overflow on a stripe that has a slick slider 
        $('.score-slick-slider').closest('.score-stripe').addClass('overflow-hidden position-relative');
        $('.article-collection').closest('.score-stripe').addClass('overflow-hidden position-relative');
        $('.slick-contents').closest('.score-stripe').addClass('overflow-hidden position-relative');

        //------------------------------------------
        // tabset animations
        //------------------------------------------
        function activeTabBarLogic($activeBar, $targetTab) {
            var leftPos = $targetTab.position().left;
            $activeBar.css({ left: leftPos });
        }

        function initAllTabsets() {

            $('.score-tab .nav-tabs, .vertical-tabAccordion .nav-tabs').each(function initialize() {
                const $container = $(this);
                const $firstLI = $container.find('.nav-tab');
                // 3 elements must be added to the first LI
                $firstLI.first().append('<div class="tab-underline-bar"></div><div class="tab-shadow"></div><div class="tab-active-bar"></div>');

                if ($container.parents(".vertical-tabAccordion").length == 0) {
                    var activeBar = $container.find(".tab-active-bar");
                    var numOfTabs = $firstLI.length;
                    activeBar.css({ width: "calc(100% / " + numOfTabs + ")" });
                    $firstLI.click(function (event) {
                        var tabLi = $(event.currentTarget);
                        activeTabBarLogic(activeBar, tabLi);
                    });

                    activeTabBarLogic(activeBar, $firstLI.first());

                    $(window).resize(function () {
                        var activeBar = $container.find(".tab-active-bar");
                        var activeTab = $container.find(".nav-tab.active");
                        activeTabBarLogic(activeBar, activeTab);
                    });
                }
            });

        }

        function initTabset() {
            // default tabset

            $('div[class="score-tab"] .nav-tabs').each(function initialize() {
                const $container = $(this);

                const $active = $container.find('.nav-tab.active').first();
                const $activeBar = $container.find('.tab-active-bar');
                const $shadow = $container.find('.tab-shadow');

                const underlineLeft = $active.position().left + 16;
                const underlineWidth = $active.outerWidth() - 32;

                const shadowLeft = $active.position().left;
                const shadowWidth = $active.outerWidth();

                $activeBar.css({ 'left': underlineLeft + 'px', 'width': underlineWidth + 'px' });
                $shadow.css({ 'left': shadowLeft + 'px', 'width': shadowWidth + 'px' });

                var activeTab = $container.find('.nav-tab.active').first();
                var activeTabPane = $($tabsetContentSlider).find(".tab-pane.active");

                const activePanelLink = activeTab.find('button');
                const activePanelLinkMessage = activePanelLink.attr('data-event-messages') || null;

                if (activePanelLinkMessage) {
                    const eventMessages = activePanelLinkMessage.split(',');
                    eventMessages.forEach(function (eventMessage) {
                        eventManager.trigger(eventMessage);
                    });
                }

                if (activeTabPane.find(".score-flex-box.slick-contents").hasClass("slick-initialized")) {
                    $tabsetContentSlider.addClass("active-tab-is-slicked-content");
                } else {
                    $tabsetContentSlider.removeClass("active-tab-is-slicked-content");
                }

            });
        };

        function initTabsetHover() {
            // handle hover

            $('div[class="score-tab"]').
                on('mouseenter focus', '.nav-tabs .nav-tab button', function () {
                    const $this = $(this);
                    const $parent = $this.parent();
                    const $container = $parent.closest('.nav-tabs');
                    const $shadow = $container.find('.tab-shadow');

                    const shadowLeft = $parent.position().left;
                    const shadowWidth = $parent.outerWidth();

                    $shadow.css({ 'left': shadowLeft + 'px', 'width': shadowWidth + 'px' });
                })
                .on('mouseleave blur', '.nav-tabs .nav-tab button', function () {
                    const $this = $(this);
                    const $container = $this.closest('.nav-tabs');
                    const $active = $container.find('.nav-tab.active').first();
                    const $shadow = $container.find('.nav-shadow');

                    const shadowLeft = $active.position().left;
                    const shadowWidth = $active.outerWidth();

                    $shadow.css({ 'left': shadowLeft + 'px', 'width': shadowWidth + 'px' });
                });

            //handle active state
            $('div[class="score-tab"]').
                on('click touch', '.nav-tabs .nav-tab button', function () {
                    const $this = $(this);
                    const $parent = $this.parent();
                    const $container = $parent.closest('.nav-tabs');
                    const $activeBar = $container.find('.tab-active-bar');

                    const underlineLeft = $parent.position().left + 15;
                    const underlineWidth = $parent.outerWidth() - 32;

                    $activeBar.css({ 'left': underlineLeft + 'px', 'width': underlineWidth + 'px' });
                });
        };

        function initVerticaTabset() {

            $('.vertical-tabset .nav-tabs').each(function initialize() {
                var winWidth = $(window).outerWidth();
                const $container = $(this);

                const $active = $container.find('.nav-tab.active').first();
                const $activeBar = $container.find('.tab-active-bar');
                const $shadow = $container.find('.tab-shadow');

                if (winWidth >= 1080) {
                    const activeTop = $active.position().top;
                    const activeHeight = $active.outerHeight();

                    $activeBar.css({ 'top': activeTop + 'px', 'height': activeHeight + 'px' });
                    $activeBar.css({ 'left': '0px', 'width': '8px' });
                    $shadow.css({ 'top': activeTop + 'px', 'height': activeHeight + 'px' });
                    $shadow.css({ 'left': '0', 'width': '100%' });
                } else {
                    const underlineLeft = $active.position().left + 16;
                    const underlineWidth = $active.outerWidth() - 32;

                    const shadowLeft = $active.position().left;
                    const shadowWidth = $active.outerWidth();

                    $activeBar.css({ 'left': underlineLeft + 'px', 'width': underlineWidth + 'px' });
                    $activeBar.css({ 'height': '8px', 'top': 'auto' });
                    $shadow.css({ 'left': shadowLeft + 'px', 'width': shadowWidth + 'px' });
                }
            });
        };

        function initVerticalTabsetHover() {

            // handle hover
            $('.vertical-tabset').
                on('mouseenter focus', '.nav-tabs .nav-tab button', function () {
                    var winWidth = $(window).outerWidth();
                    const $this = $(this);
                    const $parent = $this.parent();
                    const $container = $parent.closest('.nav-tabs');
                    const $shadow = $container.find('.tab-shadow');

                    if (winWidth >= 1080) {
                        const shadowTop = $parent.position().top;
                        const shadowHeight = $parent.outerHeight();

                        $shadow.css({ 'top': shadowTop + 'px', 'height': shadowHeight + 'px' });
                        $shadow.css({ 'left': '0', 'width': '100%' });
                    } else {
                        const shadowLeft = $parent.position().left;
                        const shadowWidth = $parent.outerWidth();

                        $shadow.css({ 'left': shadowLeft + 'px', 'width': shadowWidth + 'px' });
                    }
                })
                .on('mouseleave blur', '.nav-tabs .nav-tab button', function () {
                    var winWidth = $(window).outerWidth();
                    const $this = $(this);
                    const $container = $this.closest('.nav-tabs');
                    const $active = $container.find('.nav-tab.active').first();
                    const $shadow = $container.find('.nav-shadow');

                    if (winWidth >= 1080) {
                        const shadowTop = $active.position().top;
                        const shadowHeight = $active.outerHeight();

                        $shadow.css({ 'top': shadowTop + 'px', 'height': shadowHeight + 'px' });
                    } else {
                        const shadowLeft = $active.position().left;
                        const shadowWidth = $active.outerWidth();

                        $shadow.css({ 'left': shadowLeft + 'px', 'width': shadowWidth + 'px' });
                    }
                });

            //handle active state
            $('.vertical-tabset').
                on('click touch', '.nav-tabs .nav-tab button', function () {
                    var winWidth = $(window).outerWidth();
                    const $this = $(this);
                    const $parent = $this.parent();
                    const $container = $parent.closest('.nav-tabs');
                    const $activeBar = $container.find('.tab-active-bar');
                    if (winWidth >= 1080) {
                        const activeTop = $parent.position().top;
                        const activeHeight = $parent.outerHeight();

                        $activeBar.css({ 'top': activeTop + 'px', 'height': activeHeight + 'px' });
                    } else {
                        const activeLeft = $parent.position().left + 16;
                        const activeWidth = $parent.outerWidth() - 32;

                        $activeBar.css({ 'left': activeLeft + 'px', 'width': activeWidth + 'px' });
                        $activeBar.css({ 'top': 'auto', 'height': '8px' });
                    }
                });
        };

        function initVerticaTabsetAccordion() {

            $('.vertical-tabAccordion .nav-tabs').each(function initialize() {
                const $container = $(this);

                const $active = $container.find('.nav-tab.active').first();
                const $activeBar = $container.find('.tab-active-bar');
                const $shadow = $container.find('.tab-shadow');

                const activeTop = $active.position().top;
                const activeHeight = $active.outerHeight();

                $activeBar.css({ 'top': activeTop + 'px', 'height': activeHeight + 'px' });
                //$shadow.css({ 'left': '0px', 'width': '100%' });
            });
        };

        function initVerticalTabsetAccordionHover() {

            //handle active state
            $('.vertical-tabAccordion').on('click touch', '.nav-tabs .nav-tab button', function () {
                const $this = $(this);
                const $parent = $this.parent();
                const $container = $parent.closest('.nav-tabs');
                const $underline = $container.find('.tab-active-bar');

                const activeTop = $parent.position().top;
                const activeHeight = $parent.outerHeight();

                $underline.css({ 'top': activeTop + 'px', 'height': activeHeight + 'px' });
            });
        };
        function isTouchEnabled() {
            return ('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0);
        }
        function tabIndexArrows(navUL) {
            var arrows = navUL.find(".slick-arrow");
            arrows.each(function () {
                const currentArrow = $(this);
                if (currentArrow.attr("aria-disabled") === "true") {
                    currentArrow.attr("tabindex", "-1");
                    if (currentArrow.is(":focus")) {
                        currentArrow.blur();
                    }
                } else if (currentArrow.attr("aria-disabled") === "false") {
                    currentArrow.attr("tabindex", "0");
                }
            });
        }

        function initTouchScreenTabset() {
            const touchScreen = isTouchEnabled();
            const SLIDES_TO_SHOW_TOUCH = 1;
            const SLIDES_TO_SHOW_NON_TOUCH = 2.2;
            const SLIDES_TO_SHOW_NON_TOUCH_MOBILE = 1;

            $(".score-tab.button-tabset,.score-tab.large-button-tabset").each(function () {
                const tabset = $(this);
                const nav = tabset.find(".nav-tabs-wrapper-inner");
                const navOuter = tabset.find(".nav-tabs-wrapper-outer");
                const navUL = nav.find(".nav-tabs");

                const slickSliderContent = tabset.find(".score-slick-slider");

                var isTabContentSlickSlider = slickSliderContent !== null && slickSliderContent !== undefined && slickSliderContent.length > 0;

                if (nav.length === 0 || navUL.length === 0) {
                    return; // Skip iteration if nav or navUL is not found
                }

                const slidesToShow = touchScreen ? SLIDES_TO_SHOW_TOUCH : SLIDES_TO_SHOW_NON_TOUCH;
                const slidesToShowMobile = touchScreen ? SLIDES_TO_SHOW_TOUCH : SLIDES_TO_SHOW_NON_TOUCH_MOBILE;

                var liLenghtSum = 0;
                var listOfLi = navUL.find(".nav-tab");
                listOfLi.each(function () {
                    const currentLi = $(this);
                    const divInLi = currentLi.find("button div").width();
                    //if li is (button) is longer then take that width for calculation otherwise take the div length inside
                    if (currentLi.width() >= divInLi) {
                        liLenghtSum += currentLi.width();
                    } else {
                        liLenghtSum += divInLi;
                    }

                });

                if (((liLenghtSum) >= tabset.width()) && (tabset.width() !== 0 && liLenghtSum !== 0)) {
                    !navUL.hasClass("slick-initialized") ? navUL.slick(SlickSliderSettings.getTabsetButtonsSettings(slidesToShow, slidesToShowMobile, touchScreen)) : navUL.slick("resize");

                    navOuter.removeClass("no-slick");
                    //Go to the active tab
                    if (navUL.hasClass("slick-initialized") && touchScreen) {
                        var activeTab = navUL.find(".nav-tab.active");
                        if (activeTab.length > 0) {
                            navUL.slick('slickGoTo', activeTab.closest(".slick-slide").index());
                        }
                    } else if (navUL.hasClass("slick-initialized")) {
                        tabIndexArrows(navUL);
                    }
                } else {
                    if (navUL.hasClass("slick-initialized")) {
                        navUL.slick("unslick");

                        //reattach tabset tracking events event to navUL buttons as these are removed when unslicking
                        $(tabset).find(".score-tab-panel").removeAttr("data-tracking");
                        tabsetTrackingEvents.initialize();
                    }

                    navOuter.addClass("no-slick");
                }

                // Add touchscreen class when is touchscreen
                if (touchScreen) {
                    $(tabset).addClass("touch-screen");
                } else {
                    $(tabset).removeClass("touch-screen");
                }

                // Event delegation for tab clicks, must .off first as otherwise you attach a new listener per resize
                navUL.off("click.navUlClick", '.nav-tab-btn[role="tab"]').on('click.navUlClick', '.nav-tab-btn[role="tab"]', function () {
                    const clickedLi = $(this).closest(".nav-tab");
                    const tabID = $(this).attr("href");
                    navUL.find('.nav-tab').removeClass('active');
                    tabset.find(".tab-pane").removeClass("active");
                    clickedLi.addClass("active");
                    $(tabID).addClass("active");
                    initSlickFlexBox($(tabID));
                    if (navUL.hasClass("slick-initialized")) {
                        navUL.slick('slickGoTo', clickedLi.closest(".slick-slide").index());
                    }
                    tabIndexArrows(navUL);
                });

                //Trigger immediate class change
                requestAnimationFrame(() => {
                    adjustTabSetVisibility(tabset, navUL);
                });

                if (isTabContentSlickSlider) {
                    $(slickSliderContent).each(function () {

                        let slides = $(this).slick('slickGetOption', 'slidesToShow');

                        if ($(this).hasClass("slick-initialized")) {
                            $(this).slick("unslick");
                        }

                        $(this).slick(SlickSliderSettings.getSlickSliderSettingsNumOfSlidesOnly(slides));
                        tabIndexArrows(navUL);
                    });

                }
            });
        }

        function adjustTabSetVisibility(tabset, navUL) {

            // Cached jQuery selections
            const $container = tabset.find(".slick-list:first");
            const $liElements = $container.find("li[role='tab']");

            function isElementVisible($element, buffer = 50) {
                // Get the width of the container and its scroll position
                var containerWidth = $container.width();
                var containerScrollLeft = $container.scrollLeft();

                // Get the left position and width of the element
                var elementLeft = $element.offset().left - $container.offset().left;
                var elementWidth = $element.outerWidth();

                // Calculate the left and right boundaries of the container
                var containerLeft = containerScrollLeft;
                var containerRight = containerScrollLeft + containerWidth;

                // Calculate the right position of the element
                var elementRight = elementLeft + elementWidth;

                // Check if both sides of the element is within the visible range,
                // considering the buffer to handle potential overlaps
                var isVisible = elementLeft >= containerLeft - buffer && elementRight <= containerRight;

                // Return true if either the left or right side of the element is visible
                return isVisible;
            }

            function updateVisibility() {
                var $navTabs = navUL;
                // Reset classes and css before checking visibility
                $navTabs.removeClass("extend-left extend-right");
                $navTabs.css({ "width": "", "margin-left": "" });

                var touchScreenSlick = $navTabs.hasClass("slick-initialized") && isTouchEnabled();

                $liElements.each(function (index) {

                    var $li = $(this);
                    var $btn = $li.find("a");
                    var $slickSlide = $li.parents(".slick-slide");

                    if (isElementVisible($li)) {
                        $li.addClass("visible");
                        $btn.attr("tabindex", 0);
                        $slickSlide.attr("aria-hidden", false);
                    } else {
                        $li.removeClass("visible");
                        $btn.attr("tabindex", -1);
                        $slickSlide.attr("aria-hidden", true);
                    }
                });

                var offsetLeft = (($navTabs.offset().left > 0) ? $navTabs.offset().left : 0) + "px";
                // Add classes for extending background
                if (!$liElements.first().hasClass("visible")) {
                    if ($navTabs.hasClass("slick-initialized")) {
                        $navTabs.addClass("extend-left");
                        if (touchScreenSlick) {
                            $navTabs.css({ "margin-left": "-" + offsetLeft });
                        }
                    }
                }
                if (!$liElements.last().hasClass("visible")) {
                    if ($navTabs.hasClass("slick-initialized")) {
                        $navTabs.addClass("extend-right");
                    }
                }

                //if extending both, then it is 100vw
                //if not, then it is 100vw - the offset
                if (!$liElements.first().hasClass("visible") && !$liElements.last().hasClass("visible")) {
                    if ($navTabs.hasClass("slick-initialized")) {
                        $navTabs.addClass("extend-left extend-right");
                        if (touchScreenSlick) {
                            $navTabs.css({ "width": "100vw" });
                        }
                    }
                }
                else if (touchScreenSlick) {
                    $navTabs.css({ "width": "calc(100vw - " + offsetLeft + ")" });
                }
                tabIndexArrows(navUL);
            }

            // Initial update
            updateVisibility();

            // Throttle the update to allow event to complete for smoother updates
            const throttledUpdateVisibility = _.throttle(updateVisibility, 5);

            // Add "swipe" event listener
            navUL.on('swipe', function () {
                throttledUpdateVisibility();
            });
            // Fallback afterChange event for when users swipe too far & slick slingshots back
            navUL.on('afterChange', function () {
                throttledUpdateVisibility();
            });
        }

        function initSlickFlexBox(container) {
            var flexBoxContainer = $(container).find(".score-flex-box.slick-contents");
            if ($("body").hasClass("mode-experience-editor") || flexBoxContainer == null || flexBoxContainer.length < 1) {
                // either in experience editor or nothing to be slicked
                return;
            }

            flexBoxContainer.each(function () {
                var flexbox = $(this);
                var cards = flexbox.find(".sage-product-card-alt .header");
                var isCards = cards !== null && cards.length > 0;

                if (isCards) {
                    // let specific slick product card function handle slicking
                    flexbox.addClass("slick-cards");
                    initSlickProductCards(flexbox);
                    return;
                }

                // stop opacity: 0 happening when slicking/unslicking
                flexbox.parent().addClass("animations-off");

                var noOfFlexItems = flexbox.find(".flex-item").length;
                var windowWidth = $(window).outerWidth();

                var slickSettings = flexbox.hasClass("slick-suites") ? SlickSliderSettings.getSlickProductCardSettings() : SlickSliderSettings.getSlickSliderSettingsNumOfSlidesOnly(3);
                var maxNoOfSlidesBeforeSlicking = 0;

                if (windowWidth >= 1440) {
                    maxNoOfSlidesBeforeSlicking = 4;
                }
                else if (windowWidth >= 1080) {
                    maxNoOfSlidesBeforeSlicking = 3;
                }
                else if (windowWidth >= 768) {
                    maxNoOfSlidesBeforeSlicking = 2;
                }
                else {
                    maxNoOfSlidesBeforeSlicking = 1;
                }

                if (noOfFlexItems <= maxNoOfSlidesBeforeSlicking) {
                    // no need to have a slick slider for the flexitems as they will fit on the screen
                    // unslick if currently slicked already and then return
                    if (flexbox.hasClass("slick-initialized")) {
                        flexbox.slick("unslick");
                    }
                    $.fn.matchHeight._update();
                    return;
                }

                if (flexbox.hasClass("slick-initialized")) {
                    // flexitems need to be in slick slider but are already slicked so just return
                    var currentSlideIndex = flexbox.slick("slickCurrentSlide");
                    flexbox.slick("slickGoTo", currentSlideIndex);
                    return;
                }

                // add slick to flexbox
                flexbox.slick(slickSettings);
                var currentSlideIndex = flexbox.slick("slickCurrentSlide");
                flexbox.slick("slickGoTo", currentSlideIndex);

                flexbox.on("setPosition", function (event, slick, currentSlide, nextSlide) {
                    $.fn.matchHeight._update();
                });

                // need to add standard slider tracking once slick is initialised
                // removing data-tracking attr will allow tracking events to be readded for this slider only
                flexbox.removeAttr("data-tracking");
                sliderTrackingEvents.initialize();
            });
        }

        // set up matchheight on the slicked flexbox
        $("body").find(".score-flex-box.slick-contents").each(function () {
            $(this).find('.score-highlight .score-highlight-header').matchHeight({ byRow: true });
            $(this).find('.score-highlight .score-highlight-body').matchHeight({ byRow: true });
            $(this).find('.score-highlight .score-call-to-action').matchHeight({ byRow: true });
            $(this).find('.score-highlight .caption').matchHeight({ byRow: true });
            //matchheight bindings for the images and overall flex item will happen in lazyload (to prevent race condition)
        });

        function initSlickProductCards(productCardFlexBoxContainer) {
            // need to check slick for each "set" of product cards as suites will have 6 cards on the page but these are grouped and should not all be in the same slider
            var cards = $(productCardFlexBoxContainer).find(".sage-product-card-alt .header");
            if (cards == null || cards.length == 0) { return; }

            // stop opacity: 0 happening when slicking/unslicking
            $(productCardFlexBoxContainer).parent().addClass("animations-off");

            var noOfCardsInSlider = $(productCardFlexBoxContainer).find(".flex-item").length;
            var windowWidth = $(window).width();

            $(".sage-product-card-actions-area .score-button", productCardFlexBoxContainer).each(function () {
                $(productCardFlexBoxContainer).attr("tabindex", "0");
            });

            if ((windowWidth >= 1080 && noOfCardsInSlider <= 3) || (windowWidth < 1080 && windowWidth >= 768 && noOfCardsInSlider <= 2) || (windowWidth < 768 && noOfCardsInSlider <= 1)) {
                // no need to have a slick slider for the cards as they will fit on the screen
                // unslick if currently slicked already and then return
                if ($(productCardFlexBoxContainer).hasClass("slick-initialized")) {
                    $(productCardFlexBoxContainer).slick("unslick");
                }
                eventManager.trigger("multistep-reattach-next-step-events");
                return;
            }

            if ($(productCardFlexBoxContainer).hasClass("slick-initialized")) {
                // cards need to be in slick slider but are already slicked so just return, 
                // trigger multistep event refresh though in case breakpoint is reached and changes scope of next step buttons
                eventManager.trigger("multistep-reattach-next-step-events");
                return;
            }

            var prioritisedCardSlideIndex = 0;

            for (i = 0; i < cards.length; i++) {
                var tempCard = cards[i];
                if (tempCard.classList.contains("prioritised-card")) {
                    // first cards is prioritised
                    if (i === 0) {
                        prioritisedCardSlideIndex = 0;
                        break;
                    }
                    // last card is prioritised so use different calculation
                    if (i === noOfCardsInSlider - 1) {
                        var fullSlidesShown = 1;
                        if (windowWidth < 1080 && windowWidth >= 768) {
                            fullSlidesShown = 2;
                        }
                        else if (windowWidth >= 1080) {
                            fullSlidesShown = 3;
                        }
                        prioritisedCardSlideIndex = noOfCardsInSlider - fullSlidesShown;
                        break;
                    }
                    // middle card is prioritised 
                    if (windowWidth < 1080) {
                        prioritisedCardSlideIndex = i;
                    }
                    else {
                        prioritisedCardSlideIndex = i - 1;
                    }
                    break;
                }
            }

            // add slick to flexbox
            $(productCardFlexBoxContainer).slick(SlickSliderSettings.getSlickProductCardSettings());
            $(productCardFlexBoxContainer).slick('slickGoTo', prioritisedCardSlideIndex);

            eventManager.trigger("multistep-reattach-next-step-events");
        }

        eventManager.subscribe("slick-cards-refresh", function () {
            var productCardFlexBoxContainer = $(".score-flex-box.slick-cards");
            productCardFlexBoxContainer.each(function () {
                // if slick is enabled then go to current slide to make it slick correctly
                if ($(this).hasClass("slick-initialized")) {
                    $(this).slick('unslick');
                    $(this).slick(SlickSliderSettings.getSlickProductCardSettings());
                    eventManager.trigger("multistep-reattach-next-step-events");
                    ProductCardAlignment.refreshProductCardHeights();
                }
            })
        });

        function addGradientClass() {
            $(".score-tab.button-tabset,.score-tab.large-button-tabset").each(function () {

                const tabset = $(this);

                const gradientPanel = tabset.find(".gradient-sage-ai");
                const tabId = gradientPanel.attr("id");

                if (gradientPanel !== null && tabId !== null) {
                    $("[href='#" + tabId + "']").parent().addClass('gradient-sage-ai');
                    tabset.addClass('sage-ai');
                }

            })
        };


        initAllTabsets();
        initTabset();
        initTabsetHover();

        initVerticaTabset();
        initVerticalTabsetHover();

        initVerticaTabsetAccordion();
        initVerticalTabsetAccordionHover();

        initTouchScreenTabset();

        initSlickFlexBox($("body"));

        addGradientClass();

        //------------------------------------------
        // This will fix the modal issue when you slick and then unslick the tab set area.
        // The issue can happen when you change orientation on something like an iPad
        // because the width and length of the orientation changes the window width causing
        // the slick slider to slick and unslick the same page
        function fixModalVideo() {
            if ($tabsetContentSlider.length > 0) {
                // fix the modal video
                $modalVideo = $tabsetContentSlider.find(".sage-video-component");
                $modalToClose = $tabsetContentSlider.find(".modal.fade");
                $youtubeVideoBtn = $tabsetContentSlider.find(".youtube-video-button");

                // fix the open video button
                if ($youtubeVideoBtn.length > 0) {
                    $youtubeVideoBtn.on("click",
                        function (e) {
                            e.preventDefault();

                            if ($modalVideo.length > 0) {
                                $modalVideo
                                    .closest(".slick-track")
                                    .addClass("slick-track-disabled")
                                    .removeClass("slick-track");
                                $modalVideo
                                    .closest(".slick-list")
                                    .addClass("slick-list-disabled")
                                    .removeClass("slick-list");
                            }

                            if ($modalToClose.length > 0) {
                                // Show the modal and hide the video button
                                $modalToClose.addClass("in");
                                $modalToClose.show();
                                $youtubeVideoBtn.hide();
                                $("body").addClass("modal-open");
                            }
                        });
                }

                // fix the close button
                $buttonClose = $tabsetContentSlider.find("button.close");
                if (
                    $buttonClose.length > 0 &&
                    $modalToClose.length > 0 &&
                    $youtubeVideoBtn.length > 0
                ) {
                    $buttonClose.on("click",
                        function (e) {
                            e.preventDefault();

                            // Modal hide isn't working in this case but this does the same thing
                            $modalToClose.removeClass("in");
                            $(".modal-backdrop").remove();
                            $modalToClose.hide();
                            $youtubeVideoBtn.show();
                            $("body").removeClass("modal-open");

                            // Grab the iframe youtube and pass the parameters to pause the video
                            var $youtubeIframe = $tabsetContentSlider.find("iframe")[0].contentWindow;
                            $youtubeIframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                        });
                }
            }
        }

        function adjustHomeTabHeight() {
            if ($homeNavSlider.length > 0) {
                var lastTab = $(
                    ".sage-tab-outer .nav.nav-tabs > .nav-tab:last-of-type > button:not(.sage-tab-inner .nav.nav-tabs > .nav-tab:last-of-type > button)"
                ).offset().top;
                var topOfTabs = $(
                    ".sage-tab-outer .nav.nav-tabs:not(.sage-tab-inner .nav.nav-tabs)"
                ).offset().top;
                var disToTab = lastTab - topOfTabs + 140;

                //Adjust the person highlight height to size of the tabs
                $(".silhouette-highlight").css("top", disToTab + "px");
            }
        }

        //Adjust the height of the pic pane in carousel
        $(".campaign-carousel .score-carousel-pic-pane-body"
        ).matchHeight({
            byRow: false
        });

        $('.score-carousel').each(function () {
            $(this).find('.score-carousel-pic-pane').matchHeight({
                byRow: false
            });
        });

        var doneDown = false,
            doneUp = false;
        $(window)
            .on("resize",
                function () {
                    var winWidth = $(window).width();
                    //initialize slick slider on tabs

                    if (winWidth < 960) {
                        // fix for modal with a video inside of a slick slider
                        fixModalVideo();

                        if (!doneDown) {
                            doneDown = true;
                            doneUp = false;

                            // set height of heroes for each carousel independently
                            $('.score-carousel').each(function () {
                                $(this).find('.score-hero, .score-section-hero').matchHeight({
                                    byRow: false
                                });
                            });
                            $('.campaign-carousel').each(function () {
                                $(this).find('.score-hero, .score-section-hero').matchHeight({
                                    byRow: false
                                });
                            });
                        }

                    } else {
                        adjustHomeTabHeight();

                        if (!doneUp) {
                            doneDown = false;
                            doneUp = true;

                            //remove height of carousel heroes
                            $(" .score-carousel .score-section-hero, .score-carousel .score-hero, .campaign-carousel .score-section-hero, .campaign-carousel .score-hero"
                            ).matchHeight({
                                remove: true
                            });
                        }
                    }
                })
            .resize();

        //add 3 square spinner
        function addSpinner(submit, context) {
            submit.addClass("with-loader");
            submit.val("");
            context.append("<div class='loader'></div>");
            var spinner = context.find('.loader');
            spinner.append("<div class='bounce bounce1'></div>");
            spinner.append("<div class='bounce bounce2'></div>");
            spinner.append("<div class='bounce bounce3'></div>");
        }

        //add mutation observer (sitecore form re-renders re-add click function)
        function addObserver(target) {
            var targetNode = document.querySelector(target).parentNode.parentNode;
            var config = { attributes: true, childList: true, subtree: true };

            // Callback function to execute when mutations are observed
            var callback = function (mutationsList, observer) {
                for (var mutation in mutationsList) {
                    var mutationItem = mutationsList[mutation];
                    if (mutationItem.type === 'childList' && mutationItem.target.className === target) {
                        var submitBtn = target + " input[type='submit']";
                        $(submitBtn).on("click",
                            function () {
                                var parent = $(this).parent();
                                var anyErrors = parent.parent().find(".field-validation-error");
                                if ($("form").valid() === true && anyErrors.length <= 0) {
                                    if (!$(this).hasClass("with-loader")) {
                                        addSpinner($(this), parent);
                                    }

                                }
                            });
                    }
                }
            };

            // Create an observer instance linked to the callback function
            var observer = new MutationObserver(callback);
            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }

        // for when to scroll after succussful submit
        function addScrollObserver(target) {
            var targetNode = document.querySelector(target).parentNode;
            var config = { attributes: true, childList: true, subtree: true };

            // Callback function to execute when mutations are observed
            var callback = function (mutationsList, observer) {
                for (var mutation in mutationsList) {
                    var mutationItem = mutationsList[mutation];
                    if (mutationItem.type === 'childList' && mutationItem.target.classList.contains("privacy-rights-request")) {
                        document.querySelector(".score-column1 .score-center .score-style-box.privacy-rights-request").scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            };

            // Create an observer instance linked to the callback function
            var observer = new MutationObserver(callback);
            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }

        //form spinner - for cloud sign up form - click show indicator of redirect happening
        $(".sage-try-login input[type='submit']").on("click",
            function () {
                var parent = $(this).parent();
                var anyErrors = parent.parent().find(".field-validation-error");
                if ($("form").valid() === true && anyErrors.length <= 0) {
                    if (!$(this).hasClass("with-loader")) {
                        addSpinner($(this), parent);
                        addObserver(".sage-try-login");
                    }

                }
            });

        $(".sage-50cloud-form input[type='submit']").on("click",
            function () {
                var parent = $(this).parent();
                var anyErrors = parent.parent().find(".field-validation-error");
                if ($("form").valid() === true && anyErrors.length <= 0) {
                    if (!$(this).hasClass("with-loader")) {
                        addSpinner($(this), parent);
                        addObserver(".sage-50cloud-form");
                    }
                }
            });

        $(".product-trial-form input[type='submit']").on("click",
            function () {
                var parent = $(this).parent();
                var anyErrors = parent.parent().find(".field-validation-error");
                if ($("form").valid() === true && anyErrors.length <= 0) {
                    if (!$(this).hasClass("with-loader")) {
                        addSpinner($(this), parent);
                        addObserver(".product-trial-form");
                    }
                }
            });

        $(".sage-hr-form input[type='submit']").on("click",
            function () {
                var parent = $(this).parent();
                var anyErrors = parent.parent().find(".field-validation-error");
                if ($("form").valid() === true && anyErrors.length <= 0) {
                    if (!$(this).hasClass("with-loader")) {
                        addSpinner($(this), parent);
                        addObserver(".sage-hr-form");
                    }
                }
            });

        $(".privacy-rights-request-form input[type='submit']").on("click",
            function () {
                var parent = $(this).parent();
                var anyErrors = parent.parent().find(".field-validation-error");
                if ($("form").valid() === true && anyErrors.length <= 0) {
                    //scroll to top on submit and remove progress buttons
                    if (!$(this).hasClass("with-loader")) {
                        addSpinner($(this), parent);
                        const $styleBox = $(".score-style-box.privacy-rights-request");
                        const $progressBarHolder = $styleBox.find(".progress-bar-holder");
                        $progressBarHolder.remove();
                        addObserver(".privacy-rights-request-form");
                        addScrollObserver(".privacy-rights-request-form");
                    }

                }
            });

        $(".form-nav-section .form-next-btn, .form-nav-section .form-back-btn").click(function (event) {
            event.preventDefault();
            const $currForm = $(this).closest('form');

            if ($currForm.hasClass('sage-hr-form') || $currForm.hasClass("privacy-rights-request-form") || $currForm.hasClass("multi-step-form")) {
                var $currSection = $currForm.find(".current-section");
                const $hiddenSection = $currForm.find(".hidden-section");
                const $currProgressBarHolder = $currForm.prev();
                const $currProgressButtons = $currProgressBarHolder.find(".progress-bar-button");

                $currSection.removeClass("current-section").addClass("hidden-section");
                $hiddenSection.removeClass("hidden-section").addClass("current-section");

                $currProgressButtons.removeClass("progress-bar-current progress-bar-completed");

                //Reset curr Section
                $currSection = $currForm.find(".current-section");

                if ($currSection.hasClass("module-selection-section")) {
                    $currProgressButtons.eq(0).addClass("progress-bar-current");
                } else if ($currSection.hasClass("company-information-section")) {
                    $currProgressButtons.eq(0).addClass("progress-bar-completed");
                    $currProgressButtons.eq(1).addClass("progress-bar-current");
                }

                //Privacy-rights-request form
                if ($currSection.hasClass("contact-details-section")) {
                    $currProgressButtons.eq(0).addClass("progress-bar-current");
                } else if ($currSection.hasClass("privacy-request-section")) {
                    $currProgressButtons.eq(0).addClass("progress-bar-completed");
                    $currProgressButtons.eq(1).addClass("progress-bar-current");
                }

                //Generic forms
                if ($currSection.hasClass("page-1")) {
                    $currProgressButtons.eq(0).addClass("progress-bar-current");
                } else if ($currSection.hasClass("page-2")) {
                    $currProgressButtons.eq(0).addClass("progress-bar-completed");
                    $currProgressButtons.eq(1).addClass("progress-bar-current");
                }

                // Scroll to the top of the form
                document.querySelector(".form-modal .score-column2.wide-right .score-right .score-style-box, .score-column1 .score-center .score-style-box.privacy-rights-request")
                    .scrollIntoView({ behavior: 'smooth', block: 'start' });

                return; // Exit the function without executing the rest of the code
            }

            var parent = $(".form-next-btn").parent();
            var anyErrors = parent.parent().find(".field-validation-error");
            var form = parent.parents("form");

            if (form.valid() && anyErrors.length <= 0) {
                $(".form-group.hidden-section").addClass("current-section");
                $(".form-group.current-section:not(.hidden-section)").removeClass("current-section")
                    .addClass("hidden-section");
                $(".form-group.current-section").removeClass("hidden-section");

                if ($(".product-trial-form")) {
                    if ($(".account-form-section").hasClass("current-section")) {
                        $(".progress-bar-button.step-1").removeClass("progress-bar-completed");
                        $(".progress-bar-button.step-1").addClass("progress-bar-current");
                        $(".progress-bar-button.step-2").removeClass("progress-bar-current");
                    } else if ($(".company-form-section").hasClass("current-section")) {
                        $(".progress-bar-button.step-2").addClass("progress-bar-current");
                        $(".progress-bar-button.step-1").removeClass("progress-bar-current");
                        $(".progress-bar-button.step-1").addClass("progress-bar-completed");
                    }
                }
            }
        });

        if ($(".accounting-form").length > 0) {
            AccountingForm.init();
        }

        $(".modal-dialog .score-youtube-video").each(function () {
            var parent = $(this).parents(".modal-dialog");
            parent.addClass("score-youtube-inside");
        });

        $(".modal-dialog .brightcove-media-rendering-container").each(function () {
            var parent = $(this).parents(".modal-dialog");
            parent.addClass("brightcove-media-inside");
        });

        // set up functionality to handle brightcove videos
        $('.brightcove-media-container-iframe iframe').each(function () {
            BrightcoveVideo.init($(this));
        });

        $(".sage-feature-check-additional-data").each(function () {
            var feature = $(this).next(".sage-feature-check-text");
            $(this).insertAfter(feature);
        });

        if ($(".container.customer-zone-outer").length > 0) {
            $(".container.customer-zone-outer .score-column2.equal .score-left .score-section-hero").each(function () {
                var additionalResources = $(this);
                var styleBox = additionalResources.parents(".container.customer-zone-outer .score-column2.equal")
                    .find(".score-right .score-style-box");
                additionalResources.appendTo(styleBox);
            });

            $(".container.customer-zone-outer .score-column2.equal .score-left").each(function () {
                if ($(this).is($(".container.customer-zone-outer .score-column2.equal .score-left")[0])) {
                    var $flexItem = $(this).parents(".score-column2.equal")
                        .find(".score-right .score-style-box .score-highlight.highlight--horizontal");
                    $flexItem.css("flex", "1 0 100%");
                    $flexItem.parent().parent(".score-right").css("width", "50%");
                }
            });

            $(".container.customer-zone-outer .score-column2.equal .score-right .score-style-box")
                .css("background-color", "transparent");

            $(".container.customer-zone-outer .score-button.customer-zone-scroll-to-top").each(function () {
                $(this).remove();
            });

            var html = '<div id="supportZoneDropDownContainer">' +
                '<select id="supportZoneDropDown" name="SupportDropDown" aria-label="Support Central Home"></select>' +
                "</div>";

            var $item = $(".score-column2.wide-right.customer-zone-inner .score-flex-box.customer-zone.left").parent();
            $item.append(html);

            $(".container.customer-zone-outer .score-flex-box.customer-zone.left .flex-item").each(function () {
                var selectValue = $(this).children("a").attr("href");
                var selectText = $(this).find(".customer-zone-select-button-title").text();

                $("#supportZoneDropDown").append($("<option/>",
                    {
                        value: selectValue,
                        text: selectText
                    }));
            });

            $(".container.customer-zone-outer .score-flex-box.customer-zone .flex-item a[href='#default']")
                .addClass("active");
        }

        if ($(".customer-success-story").length > 0) {
            //spotlight (customer success stories)
            $(".spotlight-content, .spotlight-results").delegate(
                ".customer-success-story, .customer-success-latest-cta-container",
                "click",
                function (eventObj) {
                    eventObj.preventDefault();
                    eventObj.stopPropagation();
                    var story = $(eventObj.currentTarget).find("a");
                    new customerSuccessStoryClickEvent(story.get(0)).trigger();
                    var baseUrl = $(story).attr("href");
                    if (baseUrl) {
                        var queryString = window.location.search;
                        if (queryString) {

                            baseUrl = baseUrl + queryString;
                            baseUrl = sanitizer.stripHtml(decodeURIComponent(baseUrl)); // replace any html
                        }
                        window.location.href = baseUrl;
                    }
                });

            $(".customer-success-filter-button").attr("tabindex", 0);

            $(".customer-success-back").click(function () {
                window.history.back();
            });
        }

        $(".score-megamenu-dropdown.column-2.padding-0").each(function () {
            $(this).addClass("open");
            var dropdown = $(this).find(".dropdown-menu");
            var highlightWidth = $(".overview-menu-highlight-1", dropdown).outerWidth();
            // 2 highlights plus 24px left and right padding on styleboxes around highlights
            var contentWidth = (highlightWidth * 2) + 96;
            var scrollWidth = dropdown.outerWidth() - contentWidth;

            if (scrollWidth > 0) {
                // add additional with to menu item to make each highlight correct width
                dropdown.css("width", dropdown.width() + scrollWidth + "px");
            }

            $(this).removeClass('open');
        });

        //Fixing accessibility issues with score components
        $(".sage-funnelback-search-box, .filter-result-count, [class^=score-button][class*=customer]").each(function () {
            var item = $(this);

            if (item.parent().hasClass("nav navbar-nav score-nav")) {
                item.wrap("<li style='display: flex;' role='menuitem'></li>");
            }
        });

        $(".score-megamenu").find(".score-button").addClass("navbar-btn");
        $(".score-button.navbar-btn, .score-button.navbar-btn[class*=button--]").each(function () {
            var item = $(this);

            if (item.parent().hasClass("nav navbar-nav score-nav")) {
                item.wrap("<li><div></div></li>");
            }
        });

        if ($(".score-megamenu .navbar-collapse .score-button-group").hasClass("mobile-display-last")) {
            $(".score-megamenu .navbar-collapse .score-button-group").appendTo(".score-header .score-megamenu .navbar-collapse");
        }

        $(".score-megamenu-dropdown .dropdown-menu, .score-menu-list").attr("role", "list");
        $(".nav-tabs-wrapper-inner .nav.nav-tabs").attr("role", "tablist");

        //Fixing accessibility with score component - remove role=menuitem
        $(".sticky-nav .score-megamenu .score-nav-wrapper .score-nav .navbar-collapse").find("li[role='menuitem']").removeAttr("role")

        eventManager.subscribe("add-aria-labels-to-pagination",
            function () {
                var paginationPages = $(".paginationjs-pages ul li, .pagination ul.pages li, ul.pagination li");
                if (paginationPages.length > 0) {
                    paginationPages.each(function () {
                        var label = "Page";
                        var title = $(this).attr("title");
                        var pageNum = null;
                        var addPageNumToLabel = true;
                        var isCurrentPage = false;

                        if (typeof title !== undefined) {
                            if ($(this).attr("title") === "Previous page") {
                                label = "Previous Page";
                                addPageNumToLabel = false;
                            }
                            if ($(this).attr("title") === "Next page") {
                                label = "Next Page";
                                addPageNumToLabel = false;
                            }
                        }

                        if ($(this).hasClass("active")) {
                            label = "Current Page, Page";
                            isCurrentPage = true;
                        }
                        if ($(this).hasClass("prev") || $(this).hasClass("PagedList-skipToPrevious")) {
                            label = "Previous Page";
                            addPageNumToLabel = false;
                        }
                        if ($(this).hasClass("next") || $(this).hasClass("PagedList-skipToNext")) {
                            label = "Next Page";
                            addPageNumToLabel = false;
                        }
                        if ($(this).hasClass("last") || $(this).hasClass("PagedList-skipToLast")) {
                            label = "Last Page";
                            addPageNumToLabel = false;
                        }
                        if ($(this).hasClass("PagedList-skipToFirst")) {
                            label = "First Page";
                            addPageNumToLabel = false;
                        }

                        var element = $(this).children("a, span");
                        if (typeof element !== undefined) {
                            pageNum = element.text();
                            if (parseInt(pageNum) && addPageNumToLabel) {
                                label += " " + pageNum;
                            }

                            element.attr("aria-label", label);

                            if (isCurrentPage) {
                                element.attr("aria-current", "true");
                            }
                        }
                    });
                }
            });

        setTimeout(function () {
            eventManager.trigger("add-aria-labels-to-pagination");
        }, 50);

        //check career search no results image has finished lazyloading before moving (issue for mobiles found only on real devices)
        var noResultsImage = document.querySelector(".no-results-section img");
        if (noResultsImage && noResultsImage.classList.contains("lazy")) {
            // lazyloading not finished so manually do it here
            LazyLoad.prototype.loadImage(noResultsImage);
        }

        var noResultsHero = $(".no-results-section .flex-item")[1];
        if (noResultsHero && !(noResultsHero.classList.contains("lazy-animated--finished"))) {
            // lazyloading not finished so manually do it here
            noResultsHero.classList.add("lazy-animated--finished");
        }

        // need to move the career search no results section into the career search component so it appears at the right time/right place
        var noResultsList = document.querySelector(".career-search:not(.old) .results .no-results-list");
        noResultsList && noResultsList != undefined ? noResultsList.appendChild(document.querySelector(".no-results-section")) : noResultsList;

        //attach the relevant bindings to the clear filter link
        $("#clear-filter-link") ? $("#clear-filter-link").attr("data-bind", "click: $root.showAll") : $("#clear-filter-link");

        reloadCareerSearch();

        $(".career-search .keyword-container .keyword").keyup(function () {
            var newInputWidth = $(".career-search .keyword-container.mobile").width() - $(".career-search .keyword-container.mobile .search").width() - 40;

            if ($(".career-search .keyword-container.mobile .keyword").val() == "" && $(".career-search .keyword-container.desktop .keyword").val() == "") {
                // keyword search must be empty so remove cross icon from box
                [].forEach.call(document.querySelectorAll(".career-search .keyword-container .close-icon-container"), function (el) {
                    $(el).css("display", "none");
                    $(el).attr("tabindex", "-1");
                });
                $(".career-search .keyword-container.mobile .keyword").css("width", newInputWidth - 50);
            }
            else {
                [].forEach.call(document.querySelectorAll(".career-search .keyword-container .close-icon-container"), function (el) {
                    $(el).css("display", "inline-block");
                    $(el).attr("tabindex", "0");
                });
                $(".career-search .keyword-container.mobile .keyword").css("width", newInputWidth - 88);
            }
        });

        // remove AI Badge placeholder text put in via RTE snippet
        if (!$("body").hasClass("mode-experience-editor")) {
            $(".badge-ai, .badge-ai-lg").each(function () {
                $(this).text("");
            });
        }


        function reloadCareerSearch() {
            var containerWidthDesktop = $(".career-search .keyword-container.desktop").width();
            var buttonWidthDesktop = $(".career-search .keyword-container.desktop .search").width();
            var divWidthDesktop = containerWidthDesktop - buttonWidthDesktop - 40;
            $(".career-search .keyword-container.desktop > div").css("width", divWidthDesktop);
            $(".career-search .keyword-container.desktop .keyword").css("width", divWidthDesktop - 88);


            var containerWidthMobile = $(".career-search .keyword-container.mobile").width();
            var buttonWidthMobile = $(".career-search .keyword-container.mobile .search").width();
            var divWidthMobile = containerWidthMobile - buttonWidthMobile - 40;
            $(".career-search .keyword-container.mobile > div").css("width", divWidthMobile);
            $(".career-search .keyword-container.mobile .keyword").css("width", divWidthMobile - 50);

            if ($(document).width() >= 1080) {
                // need to manually set the height of the career search component to avoid overlap with footer
                var newHeight = $(".sage-career-search").height() > $(".desktop-right-side").height() ? $(".sage-career-search").height() : $(".desktop-right-side").height();
                $(".career-search").css("height", newHeight);
            }
            else {
                $(".career-search").css("height", $(".sage-career-search").height() + $(".desktop-right-side").height() + 150);
            }
        }

        $(function () {
            var highlightNavHeading = $('header .score-megamenu .navbar-nav > li.score-megamenu-dropdown .dropdown-menu .score-highlight .caption .inner-heading');
            var contentSpotSubnavHeading = $('header .score-megamenu .navbar-nav > li.score-megamenu-dropdown .dropdown-menu .score-megamenu-content .subnav-heading h2');
            var contentSpotHeading = $('header .score-megamenu .navbar-nav > li.score-megamenu-dropdown .dropdown-menu .score-content-spot h3');
            var highlightLoginHeading = $('.login-modal .score-highlight .caption .inner-heading');

            function transformIntoDiv(elements, className) {
                for (var i = 0; i < elements.length; i++) {
                    var textContent = elements[i].innerHTML;
                    var html = '<div class="' + className + '">' + textContent + '</div>';

                    $(elements[i]).replaceWith(html);
                };
            }

            transformIntoDiv(highlightNavHeading, "highlight-title");
            transformIntoDiv(contentSpotSubnavHeading, "megamenu-subnav-heading-title");
            transformIntoDiv(contentSpotHeading, "megamenu-title");
            transformIntoDiv(highlightLoginHeading, "highlight-title");
        });

        $(function () {
            var highlightLoginHeading = $(".login-modal .score-highlight:not(:has(.image-wrapper))");

            function checkForImageWrapper(elements, className) {
                if (elements.length <= 0) return;

                for (var i = 0; i < elements.length; i++) {
                    $(elements[i]).addClass(className);
                };
            }

            checkForImageWrapper(highlightLoginHeading, "no-img");
        });

        //Add empty alt text to 
        $('img[srcset="/sitecore/images/blank.gif"]').attr("alt", "");

        if (pageMode.IsLive || pageMode.IsPreview) {
            var elements = $(".promo-item .promo-content h3");
            var ellipsis = ellipsisConfig({ lines: 4 });
            ellipsis.add(elements);
        }
        //End accessibility fixes

        $(".icon-social").text("").wrap("<div class='icon-social-wrapper'></div>");

        if ($(".score-location").length > 0 && $(".score-location").attr("data-ux-state") === "loaded") {
            if ($(".google-map-canvas")) {
                $(".google-map-canvas").attr("role", "application").removeAttr("aria-hidden");


                setTimeout(function () {
                    $(".gm-fullscreen-control img:first").attr("alt", "Full Screen");
                    $("button[title='Zoom\ in'] img:first").attr("alt", "Zoom In");
                    $("button[title='Zoom\ out'] img:first").attr("alt", "Zoom Out");
                }, 3000);
            }
        }

        $(".score-accordion").find(".score-accordion-panel").each(function (i) {
            var t = setTimeout(function (i) {
                $(this).addClass("show-accordion");
            }, 500 * i);
        });

        if ($(".tabAccordion-tabSet .tabAccordion-panel-accordion").length > 0) {
            $(".tabAccordion-accordion .tabAccordion-panel-accordion .panel-collapse .panel-body .score-column2 .score-left").remove();
        }

        // set max height for modal body
        var checkModalSize = function () {
            if ($('.modal.in').length) {
                $this = $('.modal.in')
                var headerH = $this.find('.modal-header').outerHeight();
                var bodyH = $this.find('.modal-body');
                var footerH = $this.find('.modal-footer').outerHeight();
                var marginH = $(window).width() < 768 ? 16 : 24;
                var winH = $(window).height();

                bodyH.css('max-height', (winH - 2 * marginH - footerH - headerH - 4) + 'px');
            }
        };

        var tabsetElementWidth = function (winWidth) {
            var tabNavOuterW = $('div[class="score-tab"] .nav-tabs-wrapper-inner').outerWidth();
            var tabNavParentW = $('div[class="score-tab"] .nav-tabs-wrapper-outer').outerWidth();
            //var winWidth = $(window).width();
            if (winWidth >= 1080 && (tabNavOuterW >= (tabNavParentW - 40))) {
                $('div[class="score-tab"] .nav-tabs .nav-tab').css('width', (100 / $('div[class="score-tab"] .nav-tabs .nav-tab').length) + '%')
            } else {
                $('div[class="score-tab"] .nav-tabs .nav-tab').css('width', 'auto')
            }
        }

        var moveScoreBrightcoveTabsetVideo = function () {
            // you need to manaully move the score brightcove video between tabset and accordion because this component is not duplicated in sageBootstrap like the rest of the content
            // this is because the duplication was causing issues with the player and the vifdeo was not working

            // only need to run for tabset that have a brightcove video inside
            var tabsets = $(".score-tab:has(.score-brightcove-video)");

            tabsets.each(function () {
                var tabset = $(this);
                var isDesktopVisible = tabset.find(".tabAccordion-tabSet").css("display") === "none" ? false : true;
                var isMobileVisible = tabset.find(".tabAccordion-accordion").css("display") === "none" ? false : true;

                var desktopPanels = tabset.find(".tabAccordion-tabSet .tabAccordion-panel-tabSet");
                var mobilePanels = tabset.find(".tabAccordion-accordion .tabAccordion-panel-accordion");


                desktopPanels.each(function (index) {
                    var currentDesktopPanel = $(this);
                    var currentMobilePanel = $(mobilePanels.get(index));

                    var desktopVideo = currentDesktopPanel.find(".score-brightcove-video");
                    var mobileVideo = currentMobilePanel.find(".score-brightcove-video");

                    if ((desktopVideo === null || desktopVideo.length < 1) && (mobileVideo === null || mobileVideo.length < 1)) {
                        // no brightcove video to be found in either of the panels so nothing to do, go to next panel
                        return true; // jquery equivalent of continue
                    }

                    if (isDesktopVisible && (desktopVideo === null || desktopVideo.length === 0)) {
                        // unbound event listener
                        mobileVideo.closest('.collapse').off('hidden.bs.collapse.brightcove');

                        // move the video from accordion into tabset
                        var parentPlaceholder = mobileVideo.parent().attr("id").replace("-mobile", "");
                        var desktopParent = currentDesktopPanel.find("#" + parentPlaceholder);
                        desktopParent.append(mobileVideo);
                    }
                    else if (isMobileVisible && (mobileVideo === null || mobileVideo.length === 0)) {
                        // move the video from tabset into accordion
                        var parentPlaceholder = desktopVideo.parent().attr("id") + "-mobile";
                        var mobileParent = currentMobilePanel.find("#" + parentPlaceholder);
                        var collapseParent = mobileParent.closest('.collapse');
                        collapseParent.on('hidden.bs.collapse.brightcove', function (event) {
                            var brightcoveJsVideos = desktopVideo.find(".brightcove-media-container-js .video-js");
                            brightcoveJsVideos.each(function () {
                                var videoId = $(this).attr("id");
                                videojs.getPlayer(videoId).pause();
                            });
                        });
                        mobileParent.append(desktopVideo);
                    }
                });
            });
        }

        // main function that should call all 
        // local resize functions
        var checkResize = function () {
            checkModalSize();

            // tabset & tabset vertrical chang to slick on mobile
            var winWidth = $(window).outerWidth();
            if (winWidth < 1080) {
                makeSlick();
            } else {
                makeUnSlick();
                //MatchHeight for the vertical tab panes
                $(".score-tab.vertical-tabset .tab-pane").matchHeight({
                    byRow: false
                });
            }
            tabsetElementWidth(winWidth);
            moveScoreBrightcoveTabsetVideo();
        }

        $(window).resize(function () {
            clearTimeout(window.resizedFinished);
            window.resizedFinished = setTimeout(function () {
                checkResize();

                //Call these here to prevent calling twice on load
                initTabset();
                initVerticaTabset();
                initTouchScreenTabset();
                initSlickFlexBox($("body"));
                reloadCareerSearch();
            }, 250);
        });

        checkResize();

        // HTML modification section
        // 2022 rebrand
        $('.sage-partner-search').closest('.score-stripe, .score-pic-stripe').addClass('sage-partner-search-stripe');
        $('.career-search').closest('.score-stripe, .score-pic-stripe').addClass('career-search-stripe');

        // set variable on skip link button getting focus
        $('.skip-links').on('focusin', function () {
            document.documentElement.style.setProperty('--sticky-skip-height', 40 + 'px');
        })
            .on('focusout', function () {
                document.documentElement.style.setProperty('--sticky-skip-height', 0 + 'px');
            });

        // add element to teriary button
        if ($('.button-tertiary').length) {
            $('<span class="bottom-line"></span>').appendTo('.button-tertiary');
        }

        // add element to modal link button
        if ($('.modal-link-btn').length) {
            $('<span class="bottom-line"></span>').appendTo('.modal-link-btn');
        }

        if ($('.product-card-cta-tertiary-alt').length) {
            $('<span class="bottom-line"></span>').appendTo('.product-card-cta-tertiary-alt');
        }

        if ($('.sage-solution-card-content .score-button').length) {
            $('<span class="bottom-line"></span>').appendTo('.sage-solution-card-content .score-button');
        }

        if ($('.video-result .link .score-composite-link').length) {
            $('<span class="bottom-line"></span>').appendTo('.video-result .link .score-composite-link');
        }

        if ($('.comparison-table-product-card .product-card-common-element div:last-child .score-button').length) {
            $('<span class="bottom-line"></span>').appendTo('.comparison-table-product-card .product-card-common-element div:last-child .score-button');
        }

        if ($('.sage-partner-search .get-location').length) {
            $('<span class="bottom-line"></span>').appendTo('.sage-partner-search .get-location');
        }
        if ($('.form-back-btn').length) {
            $('<span class="bottom-line"></span>').appendTo('.form-back-btn');
        }

        // add class to product card so it can get outline
        $('.sage-product-card-section-content-alt div.sage-product-card-promo-header-alt').each(function () {
            // need to do it for all product cards now as new suites will have 2 groups of cards, and one may need featured outline in each set
            $(this).closest('.sage-product-card-outer').addClass('featured-outline');
        });

        // remove link from footer copy button & add class so it can be targeted
        $(".score-footer a[href=''], .score-footer a[href='#'], .score-footer a[href='http://#']").addClass("sage-copy-text").removeAttr('href')

        //
        // just for the pattern library
        $('.pattern-library-theme-toggler').on('click', function (e) {
            e.preventDefault();
            $('.page-wrapper').toggleClass('theme-dark');
        });

        //
        //START Ensure Gated content modals are in focus and can be interacted with via keyboard
        const seekingMaxDuration = 10000;

        function waitElementExists(selector, callback) {
            var startSeekingTime = Date.now();

            if ("MutationObserver" in window) {
                var observerTimeout = undefined;

                var observationCallback = function (mutations, observerObj) {
                    mutations.forEach(function (mutation) {
                        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                            var filtered = $(mutation.addedNodes).filter(selector);
                            if (filtered.length > 0 && filtered.is(":visible")) {
                                clearTimeout(observerTimeout);
                                observerObj.disconnect();
                                callback();
                            }
                        }
                    });
                }

                var observer = new MutationObserver(observationCallback);

                observer.observe(document, { subtree: true, childList: true });
                observerTimeout = setTimeout(function () {
                    observer.disconnect();
                }, seekingMaxDuration);
            }
            else {
                var poller = setInterval(function () {
                    if ($(selector).is(":visible")) {
                        clearInterval(poller);
                        callback();
                    } else {
                        if (Date.now() - startSeekingTime > seekingMaxDuration) {
                            clearInterval(poller);
                        }
                    }
                },
                    100
                );
            }
        }

        //buttons'containers
        const buttonsContainersSelector =
            [
                ".score-nav",
                ".score-call-to-action",
                ".score-button-group"
            ].join(", ");
        const nextButtonsContainersSelector =
            [
                ".gcdc-form-group-button-wrapper"
            ].join(", ");
        //buttons
        const openingButtonFormModalSelector = "a[href^='#gate-']";
        const nextButtonFormModalSelector = "button.gcdc-form-next-button";       
        //modals
        const visibleFormModalSelector = "div.gcdc-modal-wrapper:visible";
        const openedFormModalSelector = ".gcdc-modal-wrapper.open";      
        //forms
        const formElementInFormModalSelector = ".gcdc-form-render";
        //inputs or buttons in modals
        const firstInputInFormModalSelector =
            ".gcdc-modal-wrapper.open .gcdc-form-field-wrapper input:visible:first";
        //prepare focus logic
        function focusOnGatedContentModal(openedModalSelector) {
            switch (openedModalSelector) {
                case visibleFormModalSelector:
                    waitElementExists(openedModalSelector,
                        function () {
                            waitElementExists(formElementInFormModalSelector,
                                function () {
                                    setFocusOnEachFormPage();
                                });
                        });
                    break;
                case openedFormModalSelector:
                    waitElementExists(formElementInFormModalSelector,
                        function () {
                            setFocusOnEachFormPage();
                        });
                    break;                
            }
        }

        function setFocusOnEachFormPage() {
            //focus on first page
            $(firstInputInFormModalSelector).focus();
            //focus on next pages
            $(nextButtonsContainersSelector).delegate(nextButtonFormModalSelector,
                "click",
                function () {
                    setTimeout(function () {
                        focusOnGatedContentModal(visibleFormModalSelector);
                    },
                        1000);
                });
        }

        //call the logic for modals that are displayed by the load of the page
        waitElementExists(openedFormModalSelector,
            function () {
                waitElementExists(firstInputInFormModalSelector,
                    function () {
                        setFocusOnEachFormPage();
                    });
            });
        //call the logic for modals that are displayed by clicks
        $(buttonsContainersSelector).delegate(openingButtonFormModalSelector,
            "click",
            function () {
                setTimeout(function () {
                    focusOnGatedContentModal(visibleFormModalSelector);
                },
                    1000);
            });
       
        //
        //END Ensure Gated content modals are in focus and can be interacted with via keyboard
        //

        //add new class to flex-item, if it has a class .countdown-container.large, to adjust it inside flexbox
        $(".flex-item").has(".countdown-container.large").addClass("flex-item-countdown-larger");


        //PATTERN LIBRARY
        $(".score-pl-caption .dropdown-menu").on("click",
            function (e) {
                e.stopPropagation();
            });

        FaqSchema.init();
        ProductSchema.init();

        if (pageMode.IsLive() || pageMode.IsPreview()) {
            if ($(".ccaas-trigger").length > 0 && $('.ccaas-container').length > 0) {
                setTimeout((function waitForGenesysBtn(timeout) {
                    if ($('.ccaas-container').hasClass('cx-hidden')) {
                        $('.ccaas-trigger').hide();
                        setTimeout(waitForGenesysBtn.bind(this), timeout);
                        return;
                    } else {
                        $('.ccaas-trigger').show();
                    }
                }).bind((this), 100),
                    500);
            } else {
                $('.ccaas-trigger').hide();
            }
        }

        if (pageMode.IsLive() || pageMode.IsPreview()) {
            if ($('.clickable-highlight-pane').length > 0) {
                $('.clickable-highlight-pane').each(function () {
                    var currHighlight = $(this);
                    var currHighlightsBtn = currHighlight.find('.score-button');
                    var href = currHighlightsBtn.attr("href");
                    currHighlight.wrap('<a class="score-highlight clickable-highlight-pane" href="' + href + '"></a>');
                    currHighlightsBtn.parent().remove();
                });
            }
        }

        // fix button positioning for quote alt SGWD-4662
        $('.score-highlight.customer-quote-alt').each(function (index) {
            var bgrp = $(this).find('.score-call-to-action');
            $(this).append(bgrp);
        });

        productCardSelection.checkPageCookie();

        // Check for any components using personalisation & fire an event
        const personalisedElements = document.querySelectorAll('[data-attr-personalized="true"]');

        function TriggerPersonalisationLoadedEvent() {
            if (personalisedElements.length > 0) {
                // There are elements in the NodeList, so we can proceed with the loop for sending events
                personalisedElements.forEach((element) => {
                    const componentId = element.getAttribute('id');
                    const componentName = element.getAttribute('data-ux-module');
                    const testId = element.getAttribute('data-attr-test-id');
                    const testName = element.getAttribute('data-attr-test-value');
                    const lastIndex = componentName.lastIndexOf('/');
                    var trimmedComponentName = "";

                    if (lastIndex !== -1) {
                        trimmedComponentName = componentName.substring(lastIndex + 1);
                    } else {
                        //No component name, use component ID
                        trimmedComponentName = componentId;
                    }

                    new PersonalisationOnLoad(trimmedComponentName, "Intercept Panel", testId, testName).trigger();
                });
            }
        }

        if (document.readyState === "complete") {
            //trigger the function below after some time to make sure that the page is fully loaded
            setTimeout(TriggerPersonalisationLoadedEvent, 1000);
        }

        // Select all elements with the class 'button--callBtn'
        const callBtns = document.querySelectorAll('.button--callBtn');
        const body = $("body");

        // Check if callBtns exist and the body does not have the class 'mode-experience-editor'
        if (callBtns.length > 0 && !body.hasClass("mode-experience-editor")) {
            callBtns.forEach((element) => {
                // Add a click event listener to the element
                element.addEventListener('click', () => {
                    // Get the text content of the element and remove leading/trailing whitespace
                    const phoneNumber = element.textContent.trim();
                    // Redirect to a 'tel' link to initiate a phone call
                    window.location.href = `tel:${phoneNumber}`;
                });
            });
        }


        // Check if the sticky banner & Sticky header exists on the same page
        const stickyBanner = document.querySelector('.sticky-skinny-banner');
        const stickyHeader = document.querySelector('.sticky-header');


        if (stickyBanner && stickyHeader) {
            // Get the height of the sticky banner
            const bannerHeight = stickyBanner.clientHeight;

            // Set the top position of the sticky header
            stickyHeader.style.top = `${bannerHeight}px`;
        }

        $('header .sage-search-mobile .sage-funnelback-search-box .twitter-typeahead .tt-input').attr("type", "search");

        //Update title for product card highlights with 'title-first' class
        const productCardHighlights = document.querySelectorAll(".score-highlight.product-card.title-first");

        if (productCardHighlights.length !== 0) {
            productCardHighlights.forEach((highlight) => {
                const header = highlight.querySelector(".score-highlight-header");
                const innerHeading = highlight.querySelector(".inner-heading");

                if (header && innerHeading) {
                    highlight.insertBefore(innerHeading, header);
                }
            });
        }

        window.addEventListener('load', function () {
            //Fallback to match productCard height after 500ms
            setTimeout(function () {
                ProductCardAlignment.refreshProductCardHeights();
            }, 500);
        });

        eventManager.subscribe("tealium-loaded", function () {
            const countdownTimer = document.querySelectorAll('.skinny-banner .integrated-countdown-timer');
            if (countdownTimer.length > 0) {
                for (var i = 0; i < countdownTimer.length; i++) {
                    const timer = countdownTimer[i];
                    const skinnyBanner = $(timer).closest(".skinny-banner");
                    if (skinnyBanner && skinnyBanner.css("opacity") > 0 && skinnyBanner.css("visibility") === "visible") {
                        //trigger event
                        const data = skinnyBannerEvent.GenerateEventMetadata(skinnyBanner);
                        const interval = setInterval(function () {
                            if (typeof window.tealiumConsentRegister !== "undefined" &&
                                window.tealiumConsentRegister !== null &&
                                typeof window.tealiumConsentRegister.currentDecision !== "undefined" &&
                                window.tealiumConsentRegister.currentDecision !== null) {
                                clearInterval(interval);
                                tealium.event(data);
                            }
                        }, 500);

                    }
                }
            }

        });

    };

    FrontEnd.prototype.wrapInnerImages = function wrapInnerImages(query) {
        if (query instanceof Array) {
            return query.map(function (query) { return this.wrapInnerImages(query); }, this)
        }

        [].map.call(document.querySelectorAll(query), function (el) {
            return [].map.call(el.querySelectorAll('img'), function (imgEl) {
                var wrappingDiv = document.createElement('div');
                wrappingDiv.className = 'image-wrapper';
                this.wrap(imgEl, wrappingDiv);
                return imgEl;
            }, this);
        }, this);
    }

    FrontEnd.prototype.anchorClickHandler = function anchorClickHandler(ev) {
        var elem = ev.target;
        //Check to see if button has href
        var url = elem.getAttribute('href');

        if (url == null) {
            return;
        }
        // not found, do nothing
        var hashIndex = url.indexOf("#");
        if (hashIndex == -1 || hashIndex >= url.length - 1) { return; }

        //check to see that it is not just a #
        var matchedId = url.substring(hashIndex + 1, url.length);

        //check to see it's for the current url
        if (hashIndex > 0) {
            var targetPath = url.substring(0, hashIndex);
            var targetUrl = null;
            if (targetPath.indexOf("://") >= 0) {
                targetUrl = new URL(targetPath);
            }
            else {
                targetUrl = new URL(targetPath, window.location.origin);
            }
            if (!(targetUrl.host == window.location.host && targetUrl.pathname == window.location.pathname)) {
                //Not the same page, so exit this function
                return;
            }
        }

        var foundMatch = document.querySelector('#' + matchedId + '.score-anchorpoint');

        // do nothing, element to scroll does not exist on a page
        if (!foundMatch) { return; }
        // TODO: consider to check HTMLElement.scrollIntoView(). But so far lets stay with jQuery
        $("html, body").animate(
            {
                scrollTop: foundMatch.getBoundingClientRect().top + window.scrollY
            },
            {
                duration: 750,

                step: function (now, fx) {
                    //check if final destination changed due to lazy load
                    var newOffset = foundMatch.getBoundingClientRect().top + window.scrollY;
                    //if it did scroll to new location
                    if (fx.end !== newOffset)
                        fx.end = newOffset;
                }
            },
            function () {
                location.hash = elem.getAttribute("href") ? elem.getAttribute("href") : '';
            }
        );
    }

    // utility methods
    FrontEnd.prototype.wrap = function wrap(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    }

    return new FrontEnd();
});

